import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import * as translations from './locales'

i18n
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        react: {
            useSuspense: false,
        },
    })

for(var lng in translations)
{
    i18n.addResourceBundle(lng, 'visualizer', translations[lng])
}

export default i18n
